function Certification({ sizeNum = 2 }) {
  const sizeStyle = { width: `${sizeNum}rem`, height: `${sizeNum}rem` };
  return (
    <svg
      style={sizeStyle}
      className={`flex-shrink-0 sm:block text-gray-800`}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth=".6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g>
        <path
          className="fill-white"
          d="M19.63,23H5.37C4.61,23,4,22.39,4,21.63V2.37C4,1.61,4.61,1,5.37,1h14.26C20.39,1,21,1.61,21,2.37v19.26
		C21,22.39,20.39,23,19.63,23z"
        />
      </g>
      <g>
        <rect x="6" y="7" className="st1" width="13" height="8" />
      </g>
      <line className="st1" x1="6.5" y1="9.5" x2="18.63" y2="9.5" />
      <path className="st2" d="M18.91,11.5" />
      <path className="st0" d="M6.78,11.5" />
      <line className="st1" x1="9" y1="4.5" x2="16.5" y2="4.5" />
      <line className="st1" x1="6.78" y1="11.5" x2="18.91" y2="11.5" />
      <polyline className="st1" points="20.08,17.98 13.5,17.98 13.5,22.62 " />
    </svg>
  );
}

export default Certification;
